import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { request } from '../../../request';
import backoffice from '../../../request/apis/backoffice';
import DLTransferListStyle from 'assets/jss/views/DLTransferListStyle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Tooltip, withStyles } from '@material-ui/core';
// core components
import GridItem from 'components/core/Grid/GridItem';
import Card from 'components/core/Card/Card';
import CardHeader from 'components/core/Card/CardHeader';
import CardBody from 'components/core/Card/CardBody';
import CardFooter from 'components/core/Card/CardFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid/Grid';
import Button from 'components/core/CustomButtons/Button';
import CardIcon from 'components/core/Card/CardIcon';
import DateInput from 'components/core/dateInput';
// icons
import SearchIcon from '@material-ui/icons/Search';
import { IND2IND_REQUEST_STATUS, PERMISSIONS, ROWS_PER_PAGE } from '../../../constants';
import { hasPermission } from '../../../utils';
import PaginationActions from '../../../components/core/Pagination/PaginationActions';

const Ind2IndTransferList = props => {
  const {
    classes,
    page,
    setPage,
    requestId,
    setRequestId,
    requestStatus,
    setRequestStatus,
    newSponsor,
    setNewSponsor,
    currentSponsor,
    setCurrentSponsor,
    laborer,
    setLaborer,
    createdFrom,
    setCreatedFrom,
    createdTo,
    setCreatedTo,
    processedFrom,
    setProcessedFrom,
    processedTo,
    setProcessedTo,
  } = props;

  const [isFirstFetch, setIsFirstFetch] = useState(true);

  const [filters, setFilters] = useState({
    id: requestId,
    status: requestStatus,
    new_sponsor: newSponsor,
    current_sponsor: currentSponsor,
    laborer,
    created_from: createdFrom,
    created_to: createdTo,
    processed_from: processedFrom,
    processed_to: processedTo,
  });

  const updateFilter = () => {
    setFilters({
      id: requestId,
      status: requestStatus,
      new_sponsor: newSponsor,
      current_sponsor: currentSponsor,
      laborer,
      created_from: createdFrom,
      created_to: createdTo,
      processed_from: processedFrom,
      processed_to: processedTo,
    });
  };

  const fetchRequests = async () => {
    const response = await request.GET(
      backoffice.INQUIRY_IND2IND_TRANSFER,
      { ...filters, page },
      false,
    );
    return response.data;
  };

  const {
    isLoading,
    isSuccess,
    isError,
    data: pagination,
    isRefetching,
    refetch,
    isIdle,
  } = useQuery(['inquiry.dl_transfer', filters, page], fetchRequests, {
    refetchOnWindowFocus: false,
    enabled: false,
  });

  const onSearch = event => {
    event.preventDefault();
    updateFilter();
    setPage(1);

    if (isFirstFetch) {
      refetch();
      setIsFirstFetch(false);
    }
  };

  const handleSearchById = event => {
    if (event.key === 'Enter') {
      updateFilter();
      setPage(1);

      if (isFirstFetch) {
        refetch();
        setIsFirstFetch(false);
      }
    }

    if (
      ((event.ctrlKey || event.metaKey) &&
        ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) ||
      ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(event.key)
    ) {
      return;
    }

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  };

  const changePage = p => {
    setPage(p + 1);
    refetch();
  };

  useEffect(
    () => {
      if (!isFirstFetch) {
        refetch();
      }
    },
    [filters, page, isFirstFetch],
  );

  const showDlRequest = id => event => {
    event.preventDefault();
    window.open(`/inquiries/ind2ind/${id}`, '_blank');
  };

  const processRequest = id => event => {
    event.preventDefault();
    props.history.push(`/inquiries/${id}/process`);
  };

  return (
    <Grid container>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="info" icon title="البحث" subtitle="الإستعلام عن الطلبات">
            <CardIcon color="info" isTableIcon>
              <SearchIcon />
            </CardIcon>
          </CardHeader>
          <CardBody>
            <Grid container>
              <GridItem xs={12} sm={6} md={3}>
                <input
                  className={classes.filterInput}
                  placeholder="رقم الطلب"
                  onChange={event => setRequestId(event.target.value)}
                  value={requestId}
                  onKeyDown={handleSearchById}
                />
              </GridItem>

              <GridItem xs={12} sm={6} md={3}>
                <Select
                  className={[
                    classes.filterInput,
                    classes.select,
                    !requestStatus ? classes.placeholder : {},
                  ]}
                  onChange={event => setRequestStatus(event.target.value)}
                  value={requestStatus}
                  displayEmpty
                >
                  <MenuItem disabled selected value="" className={classes.selectItem}>
                    حالة الطلب
                  </MenuItem>
                  <MenuItem value="" className={classes.selectItem}>
                    جميع الحالات
                  </MenuItem>

                  {Object.keys(IND2IND_REQUEST_STATUS).map(key => {
                    return (
                      <MenuItem value={key} className={classes.selectItem}>
                        {IND2IND_REQUEST_STATUS[key]}
                      </MenuItem>
                    );
                  })}
                </Select>
              </GridItem>

              <GridItem xs={12} sm={6} md={3}>
                <input
                  className={classes.filterInput}
                  placeholder="رقم هوية العميل الجديد"
                  onChange={event => setNewSponsor(event.target.value)}
                  value={newSponsor}
                />
              </GridItem>

              <GridItem xs={12} sm={6} md={3}>
                <input
                  className={classes.filterInput}
                  placeholder="هوية العامل\ـة"
                  onChange={event => setLaborer(event.target.value)}
                  value={laborer}
                />
              </GridItem>

              <GridItem xs={12} sm={6} md={3}>
                <DateInput
                  className={classes.filterInput}
                  placeholder="تقديم الطلب من تاريخ"
                  onChange={event => setCreatedFrom(event.target.value)}
                  value={createdFrom}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <DateInput
                  className={classes.filterInput}
                  placeholder="الى تاريخ"
                  onChange={event => setCreatedTo(event.target.value)}
                  value={createdTo}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <DateInput
                  className={classes.filterInput}
                  placeholder="معالجة الطلب من تاريخ"
                  onChange={event => setProcessedFrom(event.target.value)}
                  value={processedFrom}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <DateInput
                  className={classes.filterInput}
                  placeholder="الى تاريخ"
                  onChange={event => setProcessedTo(event.target.value)}
                  value={processedTo}
                />
              </GridItem>

              <GridItem xs={12} sm={6} md={3}>
                <input
                  className={classes.filterInput}
                  placeholder="رقم هوية العميل القديم"
                  onChange={event => setCurrentSponsor(event.target.value)}
                  value={currentSponsor}
                />
              </GridItem>

              <GridItem xs={12} sm={6} md={3}>
                <Button className={classes.searchBtn} color="primary" onClick={onSearch}>
                  بحث
                </Button>
              </GridItem>
            </Grid>
          </CardBody>
        </Card>
        {isIdle && (
          <Card>
            <div style={{ textAlign: 'center', padding: '10px' }}>اختر معطياتك واضغط زر البحث</div>
          </Card>
        )}
        {(isLoading || isRefetching) && (
          <div style={{ textAlign: 'center' }}>
            <CircularProgress className={classes.progress} />
          </div>
        )}
        {isError && (
          <Card>
            <div style={{ textAlign: 'center', padding: '10px' }}>
              حدث خطأ عند الاستعلام عن الطلبات, نرجو المحاولة مرة أخرى لاحقا
            </div>
          </Card>
        )}
        {(typeof pagination !== 'undefined' && pagination.total) === 0 && (
          <Card>
            <div style={{ textAlign: 'center', padding: '10px' }}>لا يوجد نتائج</div>
          </Card>
        )}
        {isSuccess && (
          <List
            classes={classes}
            auth={props.auth}
            pagination={pagination}
            page={page}
            onChangePage={changePage}
            onShow={showDlRequest}
            onProcess={processRequest}
          />
        )}
      </GridItem>
    </Grid>
  );
};

const List = ({ classes, auth, pagination, page, onChangePage, onProcess }) => {
  const isProcessable = processingRequest => {
    return (
      processingRequest.existence.exist &&
      processingRequest.existence.processable &&
      processingRequest.status === 'WAITING_BACKOFFICE'
    );
  };

  const tooltipMessage = processingRequest => {
    return !processingRequest.existence.exist
      ? 'يمكنك فقط معالجة الطلبات الموجودة في مكتب معالجة طلبات الأفراد الجديد'
      : 'يمكنك فقط معالجة الطلبات التي لم تتم معالجتها او تصعيدها';
  };

  return (
    <Card>
      <CardBody>
        <p>النتائج : {pagination.total || 0} طلب</p>
        <div className={classes.labelsRow}>
          <span className={classes.label}>رقم الطلب </span>
          <span className={classes.label}>حالة الطلب </span>
          <span className={classes.label}>تاريخ الطلب </span>
          <span className={`${classes.label} ${classes.l}`}>التفاصيل</span>
          <span className={classes.label} />
        </div>

        {pagination.data.length
          ? pagination.data.map(record => {
              const date = new Date(record.created_at);
              const day = `${date.getDate()}`.padStart(2, '0');
              const month = `${date.getMonth() + 1}`.padStart(2, '0');
              const year = date.getFullYear();
              return (
                <div className={classes.dataRow}>
                  <span className={classes.data}>{record.id}</span>
                  <span className={classes.data}>
                    <span className={`${classes.stateTag} ${classes[`status_${record.status}`]}`}>
                      {IND2IND_REQUEST_STATUS[record.status]}
                    </span>
                  </span>
                  <span className={classes.data}>{`${year}-${month}-${day}`}</span>
                  <span className={`${classes.data} ${classes.l}`}>
                    {`${record.laborer.occupation.label} / ${record.laborer.nationality.label} `}
                  </span>
                  <Button className={classes.showBtn} href={`/inquiries/ind2ind/${record.id}`}>
                    عرض
                  </Button>
                  {hasPermission(PERMISSIONS.INQUIRY_PROCESSING.KEY, auth) && (
                    <Tooltip
                      title={tooltipMessage(record)}
                      disableFocusListener={isProcessable(record)}
                      disableHoverListener={isProcessable(record)}
                      disableTouchListener={isProcessable(record)}
                    >
                      <span>
                        <Button
                          className={
                            isProcessable(record) ? classes.processBtn : classes.processBtnDisabled
                          }
                          disabled={!isProcessable(record)}
                          href={`/inquiries/${record.existence.backoffice_id}/process`}
                          onClick={onProcess(record.existence.backoffice_id)}
                        >
                          معالجة
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                </div>
              );
            })
          : null}
      </CardBody>
      <CardFooter>
        <div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
          <TablePagination
            style={{ border: 'none' }}
            count={pagination.total || 1}
            rowsPerPage={ROWS_PER_PAGE}
            page={page - 1}
            onChangePage={(event, thePage) => {
              onChangePage(thePage);
            }}
            ActionsComponent={PaginationActions}
            rowsPerPageOptions={[]}
            labelDisplayedRows={({ from, to, count }) => ` ${from}-${to} من أصل ${count}`}
          />
        </div>
      </CardFooter>
    </Card>
  );
};

const mapStateToProps = state => {
  return {
    auth: {
      userPermissions: state.auth.userPermissions,
      AdmRole: state.auth.AdmRole,
    },
  };
};

export default compose(
  withStyles(DLTransferListStyle),
  connect(mapStateToProps),
  withRouter,
)(Ind2IndTransferList);
